import { useEffect, useId, useRef, useState } from 'react'

import { useRfqNotifications } from '../notifications/RfqNotificationsProvider'
import { NavIcon } from './NavIcon'
import { NotificationsFeed } from './NotificationsFeed'

export const NotificationsBellPanel = () => {
  const panelId = useId()
  const buttonRef = useRef<HTMLButtonElement | null>(null)
  const panelRef = useRef<HTMLDivElement | null>(null)
  const [open, setOpen] = useState(false)
  const { unreadCount, items, markAllRead, clearAll } = useRfqNotifications()

  useEffect(() => {
    if (!open) {
      return
    }
    const handlePointerDown = (event: MouseEvent) => {
      const target = event.target as Node
      if (panelRef.current?.contains(target) || buttonRef.current?.contains(target)) {
        return
      }
      setOpen(false)
    }
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        setOpen(false)
        buttonRef.current?.focus()
      }
    }
    document.addEventListener('mousedown', handlePointerDown)
    document.addEventListener('keydown', handleEscape)
    return () => {
      document.removeEventListener('mousedown', handlePointerDown)
      document.removeEventListener('keydown', handleEscape)
    }
  }, [open])

  return (
    <div className="market-notifications-bell">
      <button
        ref={buttonRef}
        type="button"
        className="market-notifications-bell__button"
        aria-expanded={open}
        aria-controls={panelId}
        aria-label={unreadCount > 0 ? `Обновления заявок, ${unreadCount} непрочитанных` : 'Обновления заявок'}
        onClick={() => setOpen((value) => !value)}
      >
        <NavIcon name="notifications" />
        {unreadCount > 0 ? <span className="market-notifications-bell__badge">{unreadCount}</span> : null}
      </button>

      {open ? (
        <div
          ref={panelRef}
          id={panelId}
          className="market-notifications-panel"
          role="dialog"
          aria-label="Обновления заявок"
        >
          <div className="market-notifications-panel__header">
            <div className="market-notifications-panel__header-row">
              <div>
                <h2 className="market-notifications-panel__title">Обновления заявок</h2>
                <p className="market-notifications-panel__hint">Изменения статусов от поставщиков</p>
              </div>
              {items.length > 0 ? (
                <div className="market-notifications-panel__actions">
                  <button
                    type="button"
                    className="market-filters__more-toggle"
                    disabled={unreadCount === 0}
                    onClick={() => void markAllRead()}
                  >
                    Прочитать все
                  </button>
                  <button
                    type="button"
                    className="market-filters__more-toggle"
                    onClick={() => void clearAll()}
                  >
                    Очистить
                  </button>
                </div>
              ) : null}
            </div>
          </div>
          <NotificationsFeed compact limit={8} onNavigate={() => setOpen(false)} />
        </div>
      ) : null}
    </div>
  )
}
